(function($) {
	var regexUrl = /^((http|https):\/\/){0,1}(([a-z0-9]|[a-z0-9][a-z0-9\-]*[a-z0-9])\.)*([a-z0-9]|[a-z0-9][a-z0-9\-]*[a-z0-9])(:[0-9]{1,5})?$/i;
	var regexEmail = /[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
	var isInIFrame = inIFrame();
    var errorMessageStore = ErrorMessageStore;
    var $altHost = $('#altHost');
    var $emailTab = $('#emailTab');
    var $emailTabInputs = $('#emailTabContents input');
    var $applyEmail = $('#applyEmail');
    var $testEmail = $('#testEmail');
    var $emailServer = $('#emailServer');
    var $senderAddress = $('#senderAddress');
    var $canonName = $('#canonName');
    var $altName = $('#altName');
    var $canonHost = $('#canonHost');
    var $window = $(window);
    var $testEmailInput = $('#testEmailInput');
    var $testEmailDialog = $('#testEmailDialog');
    var $dialogMessage = $('.dialog-message');
    var $sendButton = $('#sendButton');
    var $cancelButton = $('#cancelButton');
    var $customHostTooltip = $('#customHostTooltip');
    
    let originalCustomUrl = '';
	
	//setup url to send messsages back to parent
	var parser = document.createElement('a');
	parser.href = istrobeUrl;
	
	// IE9, IE10, IE11 compatability workaround
	if (parser.host === "") {
		parser.href = parser.href;
	}

	var iframeParentLocation = parser.protocol + "//" + parser.host;
	
	function OnMessage(event){
		jEvent = JSON.parse(event.data); // JSON was changed to String for IE9 workaround
		//ensure event request holds 'msg' in json object, 
		//prevents unwanted behavior in ces form
		if (jEvent[0].msg === "apply" && event.origin.indexOf(iframeParentLocation) != -1) {
			doApply();
		} else {
			return;
		}
	}
	
	$.extend({
		validateEmail : function($target) {
	        var errorText = '';
	        var value = $target.val().toLowerCase();
	        
	        if (value.length > 0) {
	            var emailMatch = regexEmail.test(value);
	            
	            if (!emailMatch) {
	                errorText = emailErrorText;
	                errorMessageStore.set($target[0].id, errorText);
	            } else {
	            	errorMessageStore.remove($target[0].id);
	            }
	        } else {
	            errorText = emailRequiredErrorText;
	            errorMessageStore.set($target[0].id, errorText);
	        }
	        
	        return errorText;
		},
    	validateUrl : function($target) {
	        var errorText = '';
	        var value = $target.val();
	        
			if ($target.attr('data-dirty', 'true')) {
				var isCustomHost = $target.attr('id')==='altName';
				if (!value) {
					errorText = isCustomHost ? customUrlRequiredErrorText : smtpRequiredErrorText;
				} else if (!regexUrl.test(value)) {
					errorText = isCustomHost ? customUrlInvalidErrorText : smtpInvalidErrorText;
				}
	            errorMessageStore.set($target[0].id, errorText);
	        } else {
	        	errorMessageStore.remove($target[0].id);
	        }
	        return errorText;
	    }
    });
    
    var validateField = function(event) {
        var errorText = '';
        var $target = $(event.target);
        var validationType = $target.attr('data-type');
        
        //If the custom host isn't selected, don't validate it
        if(!(event.target.id === 'altName' && !$altHost.is(':checked'))) {
        	if (event.type === 'input' || event.type === 'keyup') {
            	$target.attr('data-dirty', 'true');
	        }
	        
	        switch (validationType) {
	            case 'email' :
	                errorText = $.validateEmail($target);
	                break;
	            case 'url' :
	                errorText = $.validateUrl($target);
	                break;
	        }
	      
	        if (errorText.length > 0) {
	            $target.addClass('invalid');
	            $emailTab.addClass('error');
	        } else {
	            $target.removeClass('invalid');
	            $emailTab.removeClass('error');
	        }
	        
	        if (!!errorText) {
                $.showErrorStatus(errorText);
	        } else {
	            $.clearStatus();
	        }
        }
    };
    
    /*
     * Validation method to help with the dirty state of the buttons so that they enable disable properly.
     * Will check if 'data-type' attribute is set on the element, if it is set to 'email', will validate
     * against the email validation function else will use the url validation function.
     */
    const isElementValid = function(element) {
    	let dataType = '';
    	if (!element) {
    		return false;
    	} else {
    		dataType = element.attr('data-type');
    		if (!dataType) {    		
    			return true;
    		}
    	}
    	return dataType === 'email' ? !$.validateEmail(element) : !$.validateUrl(element);        
    }
     
    const processButtons = function() {
    	processEnableTestButton();
    	processEnableApplyButton();
    }
    
    /**
     * Process the test button enabled / disabled state.
     */
    const processEnableTestButton = function() {
    	const elementsValid = isElementValid($emailServer) && isElementValid($senderAddress);    	    	
    	$testEmail[elementsValid ? 'removeAttr' : 'attr']('disabled', 'disabled');
    }
    
    /**
     * Process the apply button enabled / disabled state.
     */
    const processEnableApplyButton = function() {
    	let elementsValid = isElementValid($emailServer) && isElementValid($senderAddress);
    	if ($altHost.is(':checked')) {
    		elementsValid &= isElementValid($altName);
    	}
    	$applyEmail[elementsValid ? 'removeAttr': 'attr']('disabled', 'disabled');
    }
    
    /**
     * Helper method to show / hide custom host tooltip
     */
    function setShowCustomHostTooltip(show) {
    	$customHostTooltip[show ? 'removeClass' : 'addClass']('closed');
    }

	// Set values of controls from data returned from server
	// and trigger the emailLoaded event since this is the last thing we fetch on page load
	function setControlValues(data) {
	    if (!!data) {
	        if (!!data.emailServer) {
	            $emailServer.val(data.emailServer);
	        }
	        
	        if (!!data.senderAddress) {
	            $senderAddress.val(data.senderAddress);
	        }
	        
	        if (!!data.canonicalHost) {
	            $canonName.val(data.canonicalHost);
	        }
	        
	        if (!!data.altName) {
	            $altName.val(data.altName);
	            setOriginalCustomUrl();
	        }
	        
	        setShowCustomHostTooltip(!!data.altName);
	        
	        if (!!data.hostMode && data.hostMode === 'altHost') {
                $altHost.click();
	        } else {
	            $canonHost.click();
	        }
	        
	        $window.trigger('emailLoaded');
	        processButtons();
	    }
	}
	
	const setOriginalCustomUrl = function() {
		originalCustomUrl = $altName.val();
	}
	
	// Function for the apply button
	function doApply() {
		
	    if (!isInIFrame) {
	        $.displayLoadingIndicator(savingData);
	    }
	    
	    var data = {
	        emailServer : $emailServer.val(),
	        senderAddress : $senderAddress.val(),
	        hostMode : $altHost.is(':checked') ? 'altHost' : 'canonHost',
	        altName : $altName.val()
	    }
	    
		$.post('settings/saveEmail', data, handleSaveResult, 'json');
	}

	// Handle the result from the save request
	function handleSaveResult(data) {
        if (!isInIFrame) {
    		$.removeLoadingIndicator();
    		
    		if (data.success) {
    			$.showSuccessStatus(saveSuccessful);
    			setOriginalCustomUrl();
    			setShowCustomHostTooltip(false);
    		} else {
    			$.showErrorStatus(data.message);
    		}
        }
	}
	
	/**
	 * Validate and create request then send to backend to trigger test email.
	 */
	const testEmailSendButtonHandler = function() {

    	const errorText = $.validateEmail($testEmailInput);
    	
    	if (errorText.length > 0) {
    		$dialogMessage.html(errorText);
    	} else {
    		sendTestEmail();
    	}
	};
	
	/**
	 * Utility method - Remove web protocol (http || https) from url
	 */
	const removeWebProtocol = function(url) {
		if (!url) {
			return '';
		}
		return url.replace(/http:\/\/|https:\/\//, '');
	}
	
	/**
	 * Send form for the test email.
	 */
	const sendTestEmail = function() {
    	$testEmailDialog.dialog('close');
		$.displayLoadingIndicator(sendingEmailText);
		$.ajax({
			type: 'POST',
			url: `/compuware/ws/Email/test?sender=${$senderAddress.val()}`,
			data: `&receivers=${$testEmailInput.val()}&subject=${emailSubjectText}&htmlMessage=${emailBodyText}&server=${$emailServer.val()}`,
			dataType: 'json'
		})
		.done(function(data) {
			$.showSuccessStatus(emailSuccessText);
		})
		.fail(function(response) {
			$.showErrorStatus(emailFailureText + response.responseJSON.booleanResponse.message);
		})
		.always(function() {
			$.removeLoadingIndicator();
		});
	}
	
	/**
	 * Utility method - Always append a port since this will be running in a browser.
	 * Either 80 or 443 will return based on protocol.
	 */
	const getLocationPortNumber =  function() {
		if (!document.location.port) {
			return document.location.protocol.toUpperCase() === 'HTTP' ? 80 : 443;
		}
		return document.location.port;
	}
	
	var testEmailCancelButtonHandler = function(){
		$.animateCloseDialog('#testEmailDialog', '#testEmail');
		$testEmailDialog.dialog('close');
	}
	
	var testEmailClickHandler = function() {
		
		$testEmailDialog.dialog({
			modal: true,
			width: 425,
			draggable: false,
			resizable: false,
			classes: {'ui-dialog' : 'cpwr-ui-dialog testEmail-dialog'},
				buttons: {
					"Send": {
						text: sendText,
						"class": 'ok-button',
						id: 'sendButton',
						click: function () {
							testEmailSendButtonHandler();
						}
					},
					"Cancel": {
						text: cancelText,
						"class": 'cancel-button',
						id: 'cancelButton',
						click: function () {
							testEmailCancelButtonHandler();
						}
					}
				},
                open: function () {
					$.animateOpenDialog('#testEmailDialog', '#testEmail', null, null, function () {
                    	//Clear the error text on opening
						$dialogMessage.html('');
	                    $testEmailInput.focus();
                    });
                    //Making the dialog keyboard accessible
                    $testEmailDialog.keypress(function(event){
                    	var keycode = (event.keyCode ? event.keyCode : event.which);

                    	if(keycode == '13' && $sendButton.is(':focus')){
                    		sendButtonFunction();
                    	}
                    	else if(keycode == '13' && $cancelButton.is(':focus')){
                    		cancelButtonFunction();
                    	}
                    });
                }
		}); 
    };
    
    const isCustomHostDirty = function() {
    	return originalCustomUrl !== $altName.val();
    }
    
	$(document).ready(function() {
		
        $.getJSON('database/list', {
            requestType: 'list', 
            nocache: new Date().getTime()
        },
        
        function(data) {
            $('#genConfigForm').show();
            
            // Did we get a successful return?
            if (data.success && data[dbmsHost_property]) {
                window.addEventListener("message", OnMessage, false);
                
                $('input[type="radio"]').click(function(event) {
                    if (event.currentTarget.id === 'canonHost') {
                        $altName.attr('disabled', true);
                        $altName.removeClass('invalid');
                        setShowCustomHostTooltip(false);
                    } else {
                        $altName.removeAttr('disabled');
                        $altName.focus();
                    	setShowCustomHostTooltip(isCustomHostDirty());
                    }
                });

                $applyEmail.click(function(event) {
                    doApply();
                });
                
                $emailTabInputs.on('input keyup', function(event){
                	processButtons();
                	validateField(event);
                }); 
                
                
                //polyfil for placeholder tag in IE 9
                $('input, textarea').placeholder();
                
                $("html").on("click", function(){$.clearStatus();});
                
                $emailTabInputs.on('click', function(event){event.stopPropagation();});
    			$('#emailTabContents button').on('click', function(event){event.stopPropagation();});
				$testEmail.on('click', testEmailClickHandler);
				
				$altName.on('keyup', function() {
			        setShowCustomHostTooltip(!!$(this).val());
				});
				
				// Get the current configuration data
                $.getJSON('settings/list', {'nocache' : new Date().getTime()}, setControlValues);
            } else {
                var mainContents = $('.main-contents');
                mainContents.addClass('no-db');
                mainContents.html(noDatabaseText);
            }
        });
	});
})(jQuery);